// extracted by mini-css-extract-plugin
module.exports = {"input":"index-module__input___mGEG1"};